module.exports = __webpack_public_path__ + "img/gesture_guidance_card_image.022b3aae.jpg";